import { useSelector } from 'react-redux';
import './Search.scss';
import Select from '../select/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping, faBasketShopping, faBed, faBellConcierge, faBook, faBookAtlas, faBookOpen, faBreadSlice, faBuildingColumns, faChurch, faCircleNotch, faColumns, faDiamond, faDiamondTurnRight, faDumbbell, faGasPump, faGem, faKitMedical, faLandmark, faLandmarkAlt, faMartiniGlass, faMonument, faMugSaucer, faMuseum, faPalette, faPallet, faPersonDress, faSchool, faSearch, faShoePrints, faStore, faSuitcaseRolling, faTheaterMasks, faUniversity, faUserTie, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { useState, useContext, Fragment } from 'react';
import request from '../../request';
import store from '../../store/store';
import appSlice from '../../store/appSlice';
import { useNavigate } from 'react-router-dom';
import ThemeContext from '../../context/themeProvider';
import translations from '../../translations';
import citiesMetadata from '../../cities-metadata.json';

function Search(props) {
  const [selectedCategory, setSelectedCategory] = useState(-1);
  const [selectedContinent, setSelectedContinent] = useState(-1);
  const [selectedCity, setSelectedCity] = useState(-1);
  const [fetchingData, setFetchingData] = useState(false);

  const categories = useSelector((state) => state.app.categories);

  const categoryIcons = [
    {
      slug: 'restaurants',
      icon: <FontAwesomeIcon icon={faBellConcierge} size="lg" />,
    },
    {
      slug: 'supermarkets',
      icon: <FontAwesomeIcon icon={faBasketShopping} size="lg" />,
    },
    {
      slug: 'bakeries',
      icon: <FontAwesomeIcon icon={faBreadSlice} size="lg" />,
    },
    {
      slug: 'cafes',
      icon: <FontAwesomeIcon icon={faMugSaucer} size="lg" />,
    },
    {
      slug: 'greek-orthodox-churches',
      icon: <FontAwesomeIcon icon={faChurch} size="lg" />,
    },
    {
      slug: 'museums',
      icon: <FontAwesomeIcon icon={faBookOpen} size="lg" />,
    },
    {
      slug: 'greek-cultural-centers',
      icon: <FontAwesomeIcon icon={faTheaterMasks} size="lg" />,
    },
    {
      slug: 'greek-schools',
      icon: <FontAwesomeIcon icon={faSchool} size="lg" />,
    },
    {
      slug: 'travel-agencies',
      icon: <FontAwesomeIcon icon={faSuitcaseRolling} size="lg" />,
    },
    {
      slug: 'jewelry-stores',
      icon: <FontAwesomeIcon icon={faGem} size="lg" />,
    },
    {
      slug: 'clothing-stores',
      icon: <FontAwesomeIcon icon={faBagShopping} size="lg" />,
    },
    {
      slug: 'markets-outdoor-markets',
      icon: <FontAwesomeIcon icon={faStore} size="lg" />,
    },
    {
      slug: 'sightseeing-spots',
      icon: <FontAwesomeIcon icon={faBuildingColumns} size="lg" />,
    },
    {
      slug: 'nightlife-bars-clubs',
      icon: <FontAwesomeIcon icon={faMartiniGlass} size="lg" />,
    },
    {
      slug: 'historical-monuments',
      icon: <FontAwesomeIcon icon={faMonument} size="lg" />,
    },
  ];

  const cities = useSelector((state) => state.app.cities);
  const geolocation = useSelector((state) => state.app.geolocation);

  const { theme } = useContext(ThemeContext);

  const navigate = useNavigate();

  const languageCode = useSelector((state) => state.app.geolocation.languageCode);
  const t = translations[languageCode];

  function onCategorySelect(category) {
    setSelectedCategory(category.id);
  }

  function onContinentSelect(continent) {
    setSelectedContinent(continent.id);
  }

  function onCitySelect(city) {
    setSelectedCity(city.id);
  }

  function search() {
    if (fetchingData || (selectedCategory === -1 || selectedCity === -1)) {
      return false;
    }

    setFetchingData(true);
    store.dispatch(appSlice.actions.updateSearchResults([]));

    request.post(`search?languageCode=${geolocation.languageCode}`, {
      category: selectedCategory,
      city: selectedCity,
    }).then((response) => {
      store.dispatch(appSlice.actions.updateSearchResults(response.data));
      setFetchingData(false);

      navigate(`results/${cities.find((c) => c.id === selectedCity).slug}/${categories.find((c) => c.id === selectedCategory).slug}`);
    }).catch((error) => {
      setFetchingData(false);
    });
  }

  return (
    <div className={`Search view ${theme}`}>
      {
        categories.length && cities.length
          ? <div className="container">
              <Select
                placeholder={t['what-are-you-looking-for']}
                data={categories}
                icons={categoryIcons}
                onChange={onCategorySelect}
              ></Select>

              <Select
                placeholder={t['choose-continent']}
                data={Object.keys(citiesMetadata).map((continentName, i) => {
                  return { id: i + 1, name: continentName };
                })}
                onChange={onContinentSelect}
                disabled={selectedCategory === -1}
              ></Select>

              <Select
                placeholder={t['choose-city']}
                data={cities.filter((city) => {
                  if (selectedContinent > -1) {
                    return Object.values(citiesMetadata)[selectedContinent - 1].findIndex((cityMetadata) => cityMetadata.name === city.name) > -1;
                  } else {
                    return true;
                  }
                })}
                onChange={onCitySelect}
                disabled={selectedCategory === -1}
              ></Select>

              <button
                className={`btn-search ${fetchingData || (selectedCategory === -1 || selectedCity === -1) ? 'disabled' : ''}`}
                onClick={search}
              >
                {
                  fetchingData
                    ? <Fragment>
                        <FontAwesomeIcon icon={faCircleNotch} spin size="lg"></FontAwesomeIcon>
                        <span>{t['search-by-category-button']}</span>
                      </Fragment>
                    : <Fragment>
                        <FontAwesomeIcon icon={faSearch} size="lg"></FontAwesomeIcon>
                        <span>{t['search-by-category-button']}</span>
                      </Fragment>
                }
              </button>
            </div>
          : ''
      }
    </div>
  )
}

export default Search;
